import { useState } from 'react'

import { WhatsAppMessagesTab } from '@/screens/WhatsAppMessagesTab'
import { WhatsAppSettingsTab } from '@/screens/WhatsAppSettingsTab'

type WhatsAppTab = 'messages' | 'configure'

const tabs: { key: WhatsAppTab; label: string }[] = [
  { key: 'messages', label: 'Messages' },
  { key: 'configure', label: 'Configure' },
]

export function WhatsAppScreenContainer() {
  const [tab, setTab] = useState<WhatsAppTab>('messages')

  return (
    <div className="bg-slate-50 text-slate-900">
      <main className="max-w-container mx-auto px-4 py-6 space-y-5">
        <header className="space-y-3">
          <h1 className="text-xl font-semibold">WhatsApp</h1>
          <nav className="flex gap-1 border-b border-slate-200">
            {tabs.map(({ key, label }) => {
              const active = key === tab
              return (
                <button
                  key={key}
                  type="button"
                  onClick={() => setTab(key)}
                  className={`-mb-px border-b-2 px-3 py-2 text-[13px] font-medium ${
                    active
                      ? 'border-slate-900 text-slate-900'
                      : 'border-transparent text-slate-500 hover:text-slate-700'
                  }`}
                >
                  {label}
                </button>
              )
            })}
          </nav>
        </header>

        {tab === 'messages' ? <WhatsAppMessagesTab /> : <WhatsAppSettingsTab />}
      </main>
    </div>
  )
}
